import type { Channel } from '../../../api';

/**
 * Lower-case text without accents (NFD then combining marks removed), so "GÉO" matches "geo"
 * (S5 R3). `toLocaleLowerCase` without a locale: the same key in FR and EN.
 */
export function searchKey(text: string): string {
  return text.normalize('NFD').replace(/\p{M}/gu, '').toLocaleLowerCase();
}

/** Channels whose name contains the query (S5 R3, AC17). A blank query keeps them all. */
export function filterChannels(channels: readonly Channel[], query: string): Channel[] {
  const key = searchKey(query.trim());
  if (key === '') return [...channels];
  return channels.filter((channel) => searchKey(channel.title).includes(key));
}

/**
 * The two sections of mockup 4 (S5 R2, R12; Proposal, to be validated): recommended, then the
 * others. The API order is kept; an inactive channel moves to the end of its section.
 */
export function splitSections(channels: readonly Channel[]): {
  readonly recommended: Channel[];
  readonly others: Channel[];
} {
  const inactiveLast = (list: readonly Channel[]): Channel[] => [
    ...list.filter((channel) => channel.accessible),
    ...list.filter((channel) => !channel.accessible),
  ];
  return {
    recommended: inactiveLast(channels.filter((channel) => channel.recommendedByAffiliate)),
    others: inactiveLast(channels.filter((channel) => !channel.recommendedByAffiliate)),
  };
}

/** Selected channels the trader can still reach: what the footer counts (S5 R4, R8). */
export function selectedCount(channels: readonly Channel[]): number {
  return channels.filter((channel) => channel.accessible && channel.subscription !== null).length;
}

/** The join button opens Telegram links only (S5 R7, R22; Proposal, to be validated). */
export function isTelegramLink(url: string | null): url is string {
  return url?.startsWith('https://t.me/') === true;
}
